var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-3h24v24H-5z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4437",
    fillRule: "nonzero",
    d: "M12.497 3.189a6.732 6.732 0 0 1 .451 6.476 6.855 6.855 0 0 1-.529.917l-5.31 7.966a.393.393 0 0 1-.654 0l-5.344-8.009A6.423 6.423 0 0 1 .65 9.74 6.783 6.783 0 0 1 12.497 3.19zM6.803 5a1.803 1.803 0 1 0 0 3.606 1.803 1.803 0 0 0 0-3.606z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarker);
export default __webpack_public_path__ + "static/media/icon-marker.7337e5714577737ffe864ed5b8db353d.svg";
export { ForwardRef as ReactComponent };